import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import BirthDate from "components/MI/alteracao-cadastral/BirthDate";
import BirthDateAUC from "components/MI/alteracao-cadastral/BirthDateAUC";
import EditPhone from "components/MI/alteracao-cadastral/EditPhone";
import EditRegisterEmail from "components/MI/alteracao-cadastral/EditRegisterEmail";
import EmailConfirm from "components/MI/alteracao-cadastral/EmailConfirm";
import Loading from "components/layout/loading";
import NameSocial from "components/MI/alteracao-cadastral/NameSocial";
import Navbar from "components/MI/Navbar";
import TokenPhone from "components/MI/alteracao-cadastral/TokenPhone";
import UserMenu from "components/layout/userMenuNew";
import api from "services/api";

import {
  Action,
  Badge,
  Body,
  Container,
  ContainerDownload,
  Download,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
  Info,
  InfoContent,
  Label,
  PanelContainer,
} from "./styles";

export type UserInfo = {
  socialName: string;
  birthDate: string;
  phoneDdd: string;
  phoneNumber: string;
  email: string;
  document: string;
  userId: string;
  customerCode: string;
};

const MeusDados = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>();
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [userContacts] = useState([]);
  const [emailAwait, setEmailAwait] = useState();
  const [phoneAwait, setPhoneAwait] = useState();
  const [openAUCModal, setOpenAUCModal] = useState(false);
  const [openNameSocialModal, setOpenNameSocialModal] = useState(false);
  const [openBirthDateModal, setOpenBirthDateModal] = useState(false);
  const [openEditEmailModal, setOpenEditEmailModal] = useState(false);
  const [openEditPhoneModal, setOpenEditPhoneModal] = useState(false);
  const [openEmailConfirmModal, setOpenEmailConfirmModal] = useState(false);
  const [openTokenPhoneModal, setOpenTokenPhoneModal] = useState(false);

  const selectedUnit = useSelector(
    // TODO: Revisar tipagem global redux DefaultRootState
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );

  const requestUserInfo = useCallback(async () => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const response = await api.get(`industrial/customer/v1/customers/me`, {
      headers,
    });
    const { data } = response;
    return data;
  }, [api, setUserInfo, setLoading, toast]);

  const requestGetUser = useCallback(async () => {
    const login = localStorage.getItem("@UltragazEmpresarial:document");
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const params = {
      login,
      "is-active": true,
      _limit: 1,
      _offset: 0,
    };
    const response = await api.get("industrial/customer/v1/users", {
      params,
      headers,
    });
    const { data } = response;
    return data[0];
  }, []);

  const requestInit = useCallback(async () => {
    try {
      setLoading(true);
      const responseUserInfo = await requestUserInfo();
      const responseUserId = await requestGetUser();
      setUserInfo({ ...responseUserInfo, ...responseUserId });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  }, []);

  useEffect(() => {
    requestInit();
  }, []);

  const birthDate = useMemo(() => {
    if (userInfo && userInfo.birthDate) {
      const dateSplit = userInfo.birthDate.split("-");
      return `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;
    }
    return null;
  }, [userInfo]);

  const phoneNumber = useMemo(() => {
    if (userInfo && userInfo.phoneDdd && userInfo.phoneNumber) {
      return `(${userInfo.phoneDdd}) ${userInfo.phoneNumber.slice(
        0,
        5
      )}-${userInfo.phoneNumber.slice(5)}`;
    }
    return null;
  }, [userInfo]);

  const hasEmailCheck = useMemo(() => {
    if (userContacts.length) {
      const userContactsEmails =
        userContacts.filter((contact) => contact.contactType === "EMAIL") || [];
      return !userContactsEmails.length
        ? false
        : userContactsEmails.every((contact) => contact.isValidated === false);
    }
    return false;
  }, [userContacts]);

  return (
    <>
      <Navbar selected="meus-dados">
        <UserMenu />
        <Container>
          <Header>
            <HeaderInfos>
              <HeaderTitle>Meus dados</HeaderTitle>
              <HeaderSubtitle>Verifique seus dados.</HeaderSubtitle>
            </HeaderInfos>
          </Header>
          <Body>
            <PanelContainer>
              <InfoContent>
                {/* <div>
                  <Label as="div">Nome social</Label>
                  <Info>{userInfo?.socialName}</Info>
                </div> */}
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenNameSocialModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">Data de nascimento</Label>
                  <Info>{birthDate}</Info>
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenBirthDateModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">E-mail</Label>
                  <Info>{userInfo && userInfo.email}</Info>
                  {(!userInfo || !userInfo.email) && hasEmailCheck && (
                    <Badge>Por favor, valide seu e-mail</Badge>
                  )}
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenEditEmailModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">Celular</Label>
                  <Info>{phoneNumber}</Info>
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenEditPhoneModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <ContainerDownload>
                Você pode acessar o termo de adesão
                <Download href="/static/TermoDeAdesaoMI.pdf" target="_blank">
                  clicando aqui.
                </Download>
              </ContainerDownload>
            </PanelContainer>
          </Body>
        </Container>
      </Navbar>
      <NameSocial
        openModal={openNameSocialModal}
        modalFunction={setOpenNameSocialModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
      />
      <BirthDate
        openModal={openBirthDateModal}
        modalFunction={setOpenBirthDateModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        setOpenAUCModal={setOpenAUCModal}
      />
      <BirthDateAUC openModal={openAUCModal} modalFunction={setOpenAUCModal} />
      <EditRegisterEmail
        openModal={openEditEmailModal}
        modalFunction={setOpenEditEmailModal}
        userInfo={userInfo}
        setEmailAwait={setEmailAwait}
        setOpenEmailConfirmModal={setOpenEmailConfirmModal}
      />
      <EmailConfirm
        openModal={openEmailConfirmModal}
        modalFunction={setOpenEmailConfirmModal}
        userInfo={userInfo}
        email={emailAwait}
      />
      <EditPhone
        openModal={openEditPhoneModal}
        modalFunction={setOpenEditPhoneModal}
        userInfo={userInfo}
        setPhoneAwait={setPhoneAwait}
        setOpenTokenPhoneModal={setOpenTokenPhoneModal}
      />
      <TokenPhone
        openModal={openTokenPhoneModal}
        modalFunction={setOpenTokenPhoneModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        phoneAwait={phoneAwait}
      />
      {loading && <Loading />}
    </>
  );
};

export default MeusDados;
